import { z } from 'zod';
import { cateringMonth } from '@overseer/contracts';

/**
 * Rozliczenie's URL state: the site and the month. A hand-edited month that is
 * not one becomes the default; no site means the first with an employee card.
 */
export const cateringSettlementSearchSchema = z.object({
  site: z.string().min(1).max(32).optional().catch(undefined),
  month: cateringMonth.optional().catch(undefined),
});
export type CateringSettlementSearch = z.infer<typeof cateringSettlementSearchSchema>;
